// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"33b875ab","706":"b96c7094","976":"0fd0dc33"}[chunkId] + ".chunk.css";
};